import { render, staticRenderFns } from "./SwitchChannelInfo.vue?vue&type=template&id=50debba6&"
import script from "./SwitchChannelInfo.vue?vue&type=script&lang=js&"
export * from "./SwitchChannelInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports